import React from 'react';
import styled from 'styled-components';

import { Container } from 'Components/core';

import { colors } from 'Constants';

const Accent = styled.div`
  background-color: #081f65;//${colors.accent};
  width: 50px;
  height: 50px;
`;

const Header = styled.div`
  position: relative;
  background-color: #081f65;//${colors.accent};
  font-weight:bold ;
  width: 100%;
  color:${colors.background}
  margin-left: 6px;
  padding: 0 24px;
  display: flex;
  align-items: center;

  .triangle {
    position: absolute;
    fill: ${colors.accent};
    top: 100%;
  }
`;

export default class InfoBoxHeader extends React.Component {
  render() {
    return (
      <Container style={{ marginBottom: '12px'}}>
        <Accent />
        <Header>
     
          {this.props.children}
        </Header>
      </Container>
    );
  }
}
